export enum LandingType {
    ELECTRIC = 1,
    OIL = 2,
    NATURAL_GAS = 3,
    ANALYTIC = 4,
    ADMIN = 5,
}
